export default __webpack_public_path__ + "static/media/2 Steps To Save a Life UCM_487476.aa372306.jpg";